import * as React from 'react';
import Circle from './Circle';
import Tab from './Tab';
import CircleWithTail from './CircleWithTail';
import Mobile from './Mobile';
import { withMedia, WithMediaProps } from '../../util/styles';
import {
    CircleWithTailCtaSettings,
    CircleCtaSettings,
    TabCtaSettings,
    MobileCtaSettings,
    SettingsState,
} from '../../typedefs/store';

interface Props extends WithMediaProps {
    settings: SettingsState;
    ctaClicked: () => void;
    smsCtaClicked: () => void;
}

function CtaFactory(props: Props) {
    let ctaType = props.settings.ctaType;
    if (props.isMobile && ctaType !== 'custom') ctaType = 'mobile';

    switch (ctaType) {
        case 'circle':
            return <Circle {...props} settings={props.settings as CircleCtaSettings} />;
        case 'tab':
            return <Tab {...props} settings={props.settings as TabCtaSettings} />;
        case 'circle with tail':
            return <CircleWithTail {...props} settings={props.settings as CircleWithTailCtaSettings} />;
        case 'mobile':
            return <Mobile {...props} settings={props.settings as MobileCtaSettings} />;
        case 'custom':
            return null;
        default:
            return null;
    }
}

export default withMedia(CtaFactory);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Cta/CtaFactory.tsx